import FooterFr from 'components/FooterFr'
import MobileFooterFr from 'components/MobileFooterFr'
import MobileNavbarFr from 'components/MobileNavbarFr'
import NavbarFr from 'components/NavbarFr'
import ProgramAllFr from 'components/Program/ProgramAllFr'
import React from 'react';
import { useSelector } from "react-redux";

function ProgramFr() {

  const isMobile = useSelector(state => state.windowSize.isMobile);

  return (
    <>
    {isMobile ? (
      <>
      <MobileNavbarFr />
      <ProgramAllFr />
      <MobileFooterFr />
      </>
    ) : (
      <>
      <NavbarFr />
      <ProgramAllFr />
      <FooterFr />
      </>
    )}
    </>
  )
}

export default ProgramFr